import { useContext } from "react";
import { ProductTourContext } from "@/components/product-tour/ProductTourProvider";
import type { ProductTourContextValue } from "@/components/product-tour/types";

export function useProductTour(): ProductTourContextValue {
  const ctx = useContext(ProductTourContext);
  if (!ctx) {
    throw new Error("useProductTour must be used within a ProductTourProvider");
  }
  return ctx;
}

export { useTourStatus } from "./use-tour-status";
